import { IConfigurableLink } from '@maxpreps/shared/models/configurableLink';
import { MediaQuery } from '@maxpreps/shared/styles/breakpoint';
import THEME from '@maxpreps/shared/styles/colors';
import Font, { FONT_CONFIG } from '@maxpreps/shared/styles/font';
import StyledAnchorAsButton from '@maxpreps/shared/ui/StyledAnchor/StyledAnchorAsButton';
import React, { FC } from 'react';
import styled from 'styled-components';
import SmartAnchor from '../../corecomponents/Anchor/SmartAnchor';

const StyledCardFooterLinksContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;

  padding: 12px 20px;
  ${FONT_CONFIG.get(Font.f12_tall)?.css}
  ${MediaQuery.Tablet} {
    padding: 16px 20px;
    ${FONT_CONFIG.get(Font.f14_tall)?.css}
  }

  a,
  button {
    margin: 4px 0;
    padding: 0 8px;
    display: inline-block;
    :not(:last-child) {
      border-right: 1px solid ${THEME.general.border};
    }
  }
`;

interface ICardFooterLinksContainerProps {
  links: IConfigurableLink[];
  anchorComponent?: FC;
}

const getLink = (link: IConfigurableLink, AnchorComponent) => {
  const { text, as, asOptions } = link;

  if (as === 'button')
    return (
      // @ts-ignore
      <StyledAnchorAsButton key={text} {...asOptions}>
        {text}
      </StyledAnchorAsButton>
    );

  if (as === 'a') {
    return (
      <AnchorComponent key={text} {...asOptions}>
        {text}
      </AnchorComponent>
    );
  }
};

const CardFooterLinksContainer: React.FC<ICardFooterLinksContainerProps> = ({
  links,
  anchorComponent
}) => (
  <StyledCardFooterLinksContainer>
    {links.map(l => getLink(l, anchorComponent ?? SmartAnchor))}
  </StyledCardFooterLinksContainer>
);

export default CardFooterLinksContainer;
